import type { ServerGridFilter } from './gridFilterTypes';

// A persisted filter is junk unless at least one of its `where` conditions carries a real value.
// A non-empty string sentinel like the "(None)" option ('--') IS a value and must survive — only
// null/undefined, '' (after trim), and empty arrays are considered empty. Booleans and 0 are values.
function hasMeaningfulValue(value: unknown): boolean {
  if (value == null) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  if (Array.isArray(value)) return value.some((entry) => hasMeaningfulValue(entry));
  return true;
}

// `not: null` is the one place a null IS the constraint — "is not blank". `equals: null` carries
// nothing and stays junk, which this module already pins.
const isActiveCondition = (condition: ServerGridFilter['where'][number]): boolean =>
  Object.entries(condition).some(
    ([key, value]) => key !== 'mode' && ((key === 'not' && value === null) || hasMeaningfulValue(value))
  );

/** Drops filter entries that would persist no active constraint (empty `where`, or all conditions blank). */
export function stripEmptyFilters(filters: ServerGridFilter[] | null | undefined): ServerGridFilter[] {
  if (!filters) return [];
  return filters.filter((filter) => filter.where?.some(isActiveCondition));
}
